/** @type {string} */
const tabComponent = 'Tab';
export default tabComponent;
